import "./polyfills";

/* Theme Project Override */
import { FrieslandCampina } from "./friesland-campina";
import { RadBoud } from "./radboud";
import { AlgoritmExperience } from "./algoritm-experience";
import { storyTelling } from "./story-telling";

import * as Blocks from "./themes/blocks";
import * as Pages from "./themes/pages";

/* Static Page */
import * as StaticScripts from "./themes/static";

/* Game Logic */
import BD_GAME_LOGIC from "@bd-core/game-logic";

FrieslandCampina();
RadBoud();
AlgoritmExperience();
storyTelling();

//Blocks object
Object.keys(Blocks).forEach((key) => new Blocks[key]());

//Pages object
Object.keys(Pages).forEach((key) => Pages[key]());

//Static Scripts
Object.keys(StaticScripts).forEach((key) => StaticScripts[key]());

//Game logic initialize
BD_GAME_LOGIC.init();
